import { useState } from 'react';
import { consumeCameFromListing } from '@/utils/helpers';

export const useCameFromListing = (key?: string): boolean => {
  const [consumed, setConsumed] = useState(() => ({ key, value: consumeCameFromListing() }));

  if (consumed.key !== key) {
    setConsumed({ key, value: consumeCameFromListing() });
    return false;
  }

  return consumed.value;
};
